import { lazy } from "react";
import { RouteProps } from "react-router-dom";
import { paymentStatusRoute } from "./PaymentStatus/route";

const routes: RouteProps[] = [
  {
    path: "/kit",
    exact: true,
    component: lazy(() => import("../pages/Kit")),
  },
  paymentStatusRoute,
];

export default routes;
